import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import {
  setTransmitalsData,
  setTransmitalMetadata,
  setTransmittalAccess,
  setTransmittalDataForReviews,
  setTransmittalReferences,
  setTransmittalVersions,
  mergeTransmitalsData,
} from "../reducers/transmitals";

export async function saveTransmitalsData(data) {
  return await axiosWrapper.post(`${getBackendUrl()}/transmittals/saveTransmittalsData`, data);
}

export async function getTransmittalAttachedFiles(data) {
  return await axiosWrapper.post(`${getBackendUrl()}/transmittals/getFilesAttachedToTransmittal`, data);
}

export function getTransmittalAccess(data) {
  return async (dispatch) => {
    const responseData = await axiosWrapper.post(`${getBackendUrl()}/transmittals/isTransmittal403`, data);
    if (responseData.data.status) {
      dispatch(setTransmittalAccess(responseData.data));
    }
  };
}

export {
  setTransmitalsData,
  setTransmitalMetadata,
  setTransmittalAccess,
  setTransmittalDataForReviews,
  setTransmittalReferences,
  mergeTransmitalsData,
};

export function getTransmittalFileVersionsForSpace(data) {
  return async (dispatch) => {
    const responseData = await axiosWrapper.post(
      `${getBackendUrl()}/transmittals/getTransmittalFileVersionsForSpace`,
      data,
    );
    if (responseData.data) {
      dispatch(setTransmittalVersions(responseData.data));
    }
  };
}

export function getTransmittals(params) {
  return async (dispatch) => {
    let urlParams = "";
    let postData = {};

    if (params.transmittalVersionId) {
      urlParams = "/transmittals/getTransmittalDataById";
      postData = {
        transmittalId: params.transmittalVersionId,
      };
    }
    await axiosWrapper.post(`${getBackendUrl()}${urlParams}`, postData).then((response) => {
      if (response.data.status) {
        dispatch(setTransmitalsData(response.data.data));
        if (response.data.metadata) {
          dispatch(setTransmitalMetadata(response.data.metadata));
        }
      }
    });
  };
}
